import React from 'react';

import SelectBox   from '../SelectBox';
import Label       from '../Label';
import InlineError from '../InlineError';

class VenueSelect extends React.Component {

    render() {

        return (
            <div>
                <Label isRequired="true">Venue</Label>

                <SelectBox { ...this.props.venueId } errors={ this.props.venueId.error }>

                    {
                        this.props.venues.map((venue, index) => {

                            return (
                                <option key={ index } value={ venue.id }>
                                    { venue.address.address_1 }, { venue.address.post_code }
                                </option>
                            )
                        })
                    }

                </SelectBox>

                <InlineError errors={ this.props.venueId.error } />
            </div>
        );
    }
}

export default VenueSelect;


// WEBPACK FOOTER //
// ./components/VenueSelect/index.js